import React from 'react';
import { Link } from 'react-router';
import { DeleteDialog } from 'modules/dialog';
import { connect } from 'react-redux';
import { ShowIf } from 'components/utils';
import { DialogChinhSuaCuocThanhTra } from 'modules/thanh-tra/sub-view';
import { ChiTietDoiTuongThanhTraDialog } from 'modules/dialog';
import { ThanhTra } from 'api';
import classnames from 'classnames';
import { get, isEmpty } from 'lodash';
import TextTruncate from 'react-text-truncate';

class RowItemDanhSachCuocThanhTra extends React.Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      getDSDTDeXuatXuLys: [],
      dialog: false,
      chiTietDT: false,
      checkTrung: false
    }
  }
  componentDidMount() {
    this.getDSDTDeXuatXuLy();
    this.checkTTTrung();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.item !== this.props.item) {
      this.getDSDTDeXuatXuLy();
      this.forceUpdate();
    }
  }

  componentWillReceiveProps(nextProps) {
    this.checkTTTrung();
  }

  toggleDialog(name, status) {
    if (name == 'chiTietDT') {
      this.setState({ chiTietDT: status });
    } else this.setState({ dialog: status });
    this.getDSDTDeXuatXuLy();
  }
  onSave(data) {
    this.props.onSave(data, this.props.count - 1)
  }

  getDSDTDeXuatXuLy() {
    ThanhTra.actions.getDanhSachDoiTuongDaDeXuatXuLy.request({ cuocThanhTraId: this.props.item.id }).then(res => {
      let getDSDTDeXuatXuLys = [];
      if (!isEmpty(res.data)) {
        res.data.map(item => {
          if (item) {
            getDSDTDeXuatXuLys.push(item.dttt.id);
          }
        });
      }
      this.setState({ getDSDTDeXuatXuLys });
    });
  }

  checkTTTrung() {
    let checkTrung = false;
    if (!isEmpty(this.props.totalDataDeXuat)) {
      const getDeXuat = this.props.totalDataDeXuat.find(item => item.id === this.props.item.id);
      if (!isEmpty(getDeXuat) && !isEmpty(getDeXuat.dataDeXuat)) {
        checkTrung = true;
      } else {
        checkTrung = false;
      }
    }
    this.setState({ checkTrung });
  }

  render() {
    let Data = this.props.item || {};
    let countDT = '';
    let dataItemNamThanhTra = Data && Data.keHoachThanhTraGocInfo ? Data.keHoachThanhTraGocInfo.namThanhTra : null;
    let getTen = '';
    let iDCuocThanhTra = '';
    let checkKeHoach = this.props.keHoach;
    if (Data && Data.id) {
      iDCuocThanhTra = Data.id;
    }
    if (Data && Data.doiTuongThanhTras && Data.doiTuongThanhTras.length > 0 && Data.cuocThanhTraNhieuDoiTuong === false) {
      getTen = Data.doiTuongThanhTras[0].ten;
      countDT = Data.doiTuongThanhTras.length;
    } else if (Data && Data.listDoiTuongThanhTra && Data.listDoiTuongThanhTra.length > 0 && Data.cuocThanhTraNhieuDoiTuong === false) {
      getTen = Data.listDoiTuongThanhTra[0].ten;
      countDT = Data.listDoiTuongThanhTra.length;
    } else if (Data.cuocThanhTraNhieuDoiTuong === true) {
      getTen = this.props.item.tenNhieuDoiTuongThanhTra;
      let countPre = Data.listDoiTuongThanhTra || [];
      let countNext = Data.doiTuongThanhTras || [];
      let countNext2 = Data.doiTuongThanhTrasList || [];
      if (countNext2.length > 0 || countNext.length > 0) {
        countDT = Data.doiTuongThanhTras.length || Data.doiTuongThanhTrasList.length;
      } else {
        countDT = countPre.length;
      }
    }

    return (
      <tr>
        <td>{this.props.count}</td>
        <td>
          <div className="tt-doituong mgbt10">
            <Link className={classnames('txt-underline txt-regular', {
              'highlighttratrung': this.state.checkTrung
            })}
              name='abc' onClick={this.toggleDialog.bind(this, 'chiTietDT', true)}>{Data.ten}</Link>
            <ChiTietDoiTuongThanhTraDialog name="chiTietDT" data={this.props.item} open={this.state.chiTietDT} onClose={this.toggleDialog.bind(this, 'chiTietDT', false)} />
          </div>
          <div className="tt-doituong">{countDT} đối tượng</div>
        </td>
        <td>
          {
            iDCuocThanhTra ?
              <Link className='txt-underline txt-regular' to={`/thanh-tra/cuoc-thanh-tra-trung/chi-tiet/${iDCuocThanhTra}`}>
                {
                  !isEmpty(this.props.item.noiDungThanhTra) &&
                  <TextTruncate
                    line={3}
                    truncateText="…"
                    text={get(this.props.item, 'noiDungThanhTra')} />
                }
              </Link>
              :
              <TextTruncate
                line={3}
                truncateText="…"
                text={get(this.props.item, 'noiDungThanhTra')} />
          }
        </td>
        <td>{this.props.item.thoiHanThanhTra}</td>
        <td>{this.props.item.kyThanhTra}</td>
        <td>{this.props.item.thoiGianTienHanh}</td>
        {/* <td>{this.props.item.donViChuTriInfo ? this.props.item.donViChuTriInfo.ten : '' }
            {
              !this.props.item.donViChuTriInfo.coQuanQuanLyId && this.props.isSubmit ?
                <div className="pt-form-helper-text">{msg.messageDefault}</div>
              :''
            }
        </td> */}
        {/* <td>{ this.props.item.donViPhoiHop ?  this.props.item.donViPhoiHop : '' }</td> */}
        <ShowIf condition={this.props.checkCT !== true}>
          <td>
            <div className="todo-wrap two-item">
              <ShowIf condition={this.props.item.allowEdit} >
                <div className="wrap-link-todo">
                  <Link className={classnames('itt-edit', { 'thaythe': checkKeHoach })} name="chinhSua" onClick={this.toggleDialog.bind(this, 'chinhSua', true)}>{checkKeHoach ? 'Thay thế' : 'Chỉnh sửa'}</Link>
                  <DialogChinhSuaCuocThanhTra
                    keHoach={this.props.keHoach}
                    idCS={this.props.item.id}
                    namKeHoachThanhTra={this.props.namKeHoachThanhTra ? this.props.namKeHoachThanhTra : dataItemNamThanhTra}
                    data={this.props.item}
                    isOpen={this.state.dialog}
                    onSave={this.onSave.bind(this)}
                    onClose={this.toggleDialog.bind(this, 'chinhSua', false)}
                    chucNangCuocThanhTra={this.props.item.chucNangCuocThanhTra}
                    />
                </div>
              </ShowIf>
              <ShowIf condition={this.props.item.allowDelete} >
                <DeleteDialog
                  title={'Xác nhận'}
                  labelButton={checkKeHoach ? 'Huỷ' : 'Xoá'}
                  content={`Bạn có đồng ý xóa cuộc thanh tra này không?`}
                  onSuccess={this.props.parent.handleRemove.bind(this.props.parent, this.props.item, this.props.count - 1)}
                />
              </ShowIf>
            </div>
          </td>
        </ShowIf>
      </tr>
    );
  }
}

RowItemDanhSachCuocThanhTra.defaultPops = {
  item: {},
  totalDataDeXuat: []
}

function bindStateToProps(state) {
  return {
    totalDataDeXuat: state.dataCuocThanhTra.totalDataDeXuat,
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}
  };
}
export default connect(bindStateToProps)(RowItemDanhSachCuocThanhTra);



// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra/datatable/RowItemDanhSachCuocThanhTra.jsx